export enum PublishRequestStatus {
  IN_PROGRESS = "IN_PROGRESS",
  APPROVE = "APPROVED",
  REJECT = "REJECTED",
  CREATED = "CREATED",
  COMPLETED = "COMPLETED",
}
